import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Header from '../../components/header';
import Sidebar from '../../components/sidebar';
import Footer from '../../components/footer';
import * as XLSX from 'xlsx';

const PaymentReport = () => {
  const [routeSummary, setRouteSummary] = useState([]);
  const [monthFilter, setMonthFilter] = useState('');
  const [yearFilter, setYearFilter] = useState(new Date().getFullYear());
  const [currentPage, setCurrentPage] = useState(1);
  const perPage = 10;
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(false);

  const fetchDealerSummary = async () => {
    try {
      setLoading(true);
      const res = await axios.post(
        'https://api.trucoo.in/dealers/payments-report/',
        { monthFilter, yearFilter, currentPage, perPage },
        { headers: { 'Content-Type': 'application/json', 'X-API-KEY': 'erpTrucoo' } }
      );
      console.log("response", res);
      if (res.data.status === 'success') {
        setRouteSummary(res.data.data || []);
        setTotalPages(res.data.data?.[0]?.totalPages || 1);
      }
    } catch (error) {
      console.error("Fetch error:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDealerSummary();
  }, [monthFilter, yearFilter, currentPage]);

  const downloadExcel = () => {
    const ws = XLSX.utils.table_to_sheet(document.getElementById('dealerSummaryTable'));
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Dealer Report');
    XLSX.writeFile(wb, 'Dealer_Report.xlsx');
  };

  // Calculate grand totals
  const grandTotalDebit = routeSummary.reduce((total, route) => total + parseFloat(route.totalPayment || 0), 0);
  const grandTotalCredit = routeSummary.reduce((total, route) => total + parseFloat(route.totalPaymentReceived || 0), 0);
  const grandTotalOpeningBalance = routeSummary.reduce((total, route) => total + parseFloat(route.openingBalance || 0), 0);
  const grandTotalCurrentBalance = routeSummary.reduce((total, route) => total + parseFloat(route.currentBalance || 0), 0);
  return (
    <>
      <Header />
      <Sidebar />
      <div className="content-wrapper">
        <div className="container-full">
          <section className="content">
            <div className="box">
              <div className="box-header with-border">
                <h4 className="box-title">Dealer Report</h4>
                <p className="mb-0 box-subtitle">Dealer grouped by route</p>
              </div>
              <div className="box-body">
                <div className="row mb-3">
                  {/* Month Filter */}
                  <div className="col-md-3">
                    <select
                      className="form-control"
                      value={monthFilter}
                      onChange={e => { setMonthFilter(e.target.value); setCurrentPage(1); }}
                    >
                      <option value="">All Months</option>
                      {[...Array(12)].map((_, idx) => (
                        <option key={idx + 1} value={idx + 1}>
                          {new Date(0, idx).toLocaleString('default', { month: 'long' })}
                        </option>
                      ))}
                    </select>
                  </div>

                  {/* Year Filter */}
                  <div className="col-md-3">
                    <select
                      className="form-control"
                      value={yearFilter}
                      onChange={e => { setYearFilter(e.target.value); setCurrentPage(1); }}
                    >
                      {[...Array(5)].map((_, idx) => {
                        const year = new Date().getFullYear() - idx;
                        return (
                          <option key={year} value={year}>
                            {year}
                          </option>
                        );
                      })}
                    </select>
                  </div>

                  <div className="col-md-6 text-right" align="right">
                    <button className="btn btn-primary" onClick={downloadExcel}>Download Excel</button>
                  </div>
                </div>

                {loading ? (
                  <div className="text-center my-4">
                    <span className="ml-2">Loading...</span>
                  </div>
                ) : (
                  <div className="table-responsive">
                    <table id="dealerSummaryTable" className="table table-bordered table-hover">
                      <thead>
                        <tr>
                          <th>S.No</th>
                          <th>Dealer</th>
                          <th>Opening Balance</th>
                          <th>Debit</th>
                          <th>Credit</th>
                          <th>Current Balance</th>
                        </tr>
                      </thead>
                      <tbody>
                        {routeSummary.map((route, routeIdx) => (
                          <React.Fragment key={route.routeId}>
                            <tr className="table-secondary">
                              <td colSpan="2" style={{ fontWeight: 'bold' }}>
                                Route: {route.routeName}
                              </td>
                              <td style={{ fontWeight: 'bold' }}>
                                {Math.abs(parseFloat(route.openingBalance)).toFixed(2)}{" "}
                                {parseFloat(route.openingBalance) < 0 ? "Cr" : "Dr"}
                              </td>
                              <td style={{ fontWeight: 'bold' }}>
                                {parseFloat(route.totalPayment).toFixed(2)}
                              </td>
                              <td style={{ fontWeight: 'bold' }}>
                                {parseFloat(route.totalPaymentReceived).toFixed(2)}
                              </td>
                              <td style={{ fontWeight: 'bold' }}>
                                {Math.abs(parseFloat(route.currentBalance)).toFixed(2)}{" "}
                                {parseFloat(route.currentBalance) < 0 ? "Cr" : "Dr"}
                              </td>
                            </tr>
                            {route.dealers.map((dealer, idx) => (
                              <tr key={dealer.dealerId}>
                                <td>{(currentPage - 1) * perPage + idx + 1}</td>
                                <td>{dealer.dealer}</td>
                                <td className={dealer.openingBalance >= 0 ? 'text-success' : 'text-danger'}>
                                  {Math.abs(parseFloat(dealer.openingBalance)).toFixed(2)}{" "}
                                  {parseFloat(dealer.openingBalance) < 0 ? "Cr" : "Dr"}
                                </td>
                                <td>{parseFloat(dealer.totalPayment).toFixed(2)}</td>
                                <td>{parseFloat(dealer.totalPaymentReceived).toFixed(2)}</td>
                                <td className={dealer.currentBalance >= 0 ? 'text-success' : 'text-danger'}>
                                  {Math.abs(parseFloat(dealer.currentBalance)).toFixed(2)}{" "}
                                  {parseFloat(dealer.currentBalance) < 0 ? "Cr" : "Dr"}
                                </td>
                              </tr>
                            ))}
                            {route.dealers.length === 0 && (
                              <tr>
                                <td colSpan="6" className="text-center text-danger">
                                  No dealers in this route
                                </td>
                              </tr>
                            )}
                          </React.Fragment>
                        ))}
                        <tr className="table-secondary">
                          <td colSpan="2" style={{ fontWeight: 'bold' }}>
                            Grand Total:
                          </td>
                          <td style={{fontWeight:'bold'}}>
                            {Math.abs(parseFloat(grandTotalOpeningBalance)).toFixed(2)}{" "}
                            {parseFloat(grandTotalOpeningBalance) < 0 ? "Cr" : "Dr"}
                          </td>
                          <td style={{ fontWeight: 'bold' }}>
                            {parseFloat(grandTotalDebit).toFixed(2)}
                          </td>
                          <td style={{ fontWeight: 'bold' }}>
                            {parseFloat(grandTotalCredit).toFixed(2)}
                          </td>
                          <td style={{fontWeight:'bold'}}>
                            {Math.abs(parseFloat(grandTotalCurrentBalance)).toFixed(2)}{" "}
                            {parseFloat(grandTotalCurrentBalance) < 0 ? "Cr" : "Dr"}
                          </td>
                        </tr>
                        {routeSummary.length === 0 && (
                          <tr>
                            <td colSpan="6" className="text-center text-danger">No Data Available</td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            </div>
          </section>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default PaymentReport;
